
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import UserChart from "./UserChart";
import PredictionsChart from "./PredictionsChart";
import RevenueChart from "./RevenueChart";
import { formattedUserData, formattedPredictionsData, formattedRevenueData } from "../data/statisticsData";

const ChartsTabsContainer: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Análise de Métricas</CardTitle>
        <CardDescription>Visualize as principais métricas do PALPITE GURU.</CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="users">
          <TabsList className="mb-4">
            <TabsTrigger value="users">Usuários</TabsTrigger>
            <TabsTrigger value="predictions">Palpites</TabsTrigger>
            <TabsTrigger value="revenue">Receita</TabsTrigger>
          </TabsList>
          
          <TabsContent value="users" className="h-[400px]">
            <UserChart data={formattedUserData} />
          </TabsContent>
          
          <TabsContent value="predictions" className="h-[400px]">
            <PredictionsChart data={formattedPredictionsData} />
          </TabsContent>
          
          <TabsContent value="revenue" className="h-[400px]">
            <RevenueChart data={formattedRevenueData} />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default ChartsTabsContainer;
